import Layouter from './layouter';

export default {
    __init__: [ 'layouter' ],
    layouter: [ 'type', Layouter ]
}